// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-female';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M15.712 16.969a7.425 7.425 0 0 0-13.424 0' />
    <path d='M9 4.219a3.72 3.72 0 0 1-3.719 3.718 3.719 3.719 0 0 0 7.438 0A3.719 3.719 0 0 1 9 4.22z' />
    <path d='M13.134 13.977a10.276 10.276 0 0 0 2.402-.713 1.062 1.062 0 0 0 .54-1.389l-.974-2.274a3.188 3.188 0 0 1-.258-1.256v-1.47a5.844 5.844 0 0 0-11.688 0v1.47c0 .432-.087.86-.258 1.256l-.974 2.274a1.063 1.063 0 0 0 .54 1.39c.769.334 1.576.573 2.402.712' />
  </g>
);

export const viewBox = '0 0 18 18';
